module.exports = __webpack_public_path__ + "static/img/wisb.3a7d0a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wisb.png
// module id = hAci
// module chunks = 1